import { SuitcaseRollingIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

export const BaggageIncluded = () => {
  const intl = useIntl();

  return (
    <div className="flex items-center gap-1">
      <SuitcaseRollingIcon size={16} />
      <span className="text-xs leading-[15px] text-text-tertiary">
        {intl.formatMessage({ id: "flights.included" })}
      </span>
    </div>
  );
};
